import { Component, Input } from '@angular/core';
import { AssetSearchResult } from 'src/app/api/asset/search/assetSearchResult';

@Component({
    selector: 'asset-search-result-item',
    templateUrl: './asset-search-result-item.component.html',
    styleUrls: ['./asset-search-result-item.component.css'],
    standalone: false
})
export class AssetSearchResultItemComponent {
  @Input() asset: AssetSearchResult | null = null;
}
